module.exports = __webpack_public_path__ + "media/images/Covd-19 Section-5a8c7fac17e3b15caed74590307b3116.svg";